/**
 * Data dell'offerta stampata nel PDF ({{deal.date}} = deals.created_at).
 * Segnalazione 9714fe60: prima di generare il PDF si chiede se portarla a oggi,
 * ma solo quando non e' gia' la data di oggi.
 *
 * Modulo puro: il "now" arriva dal chiamante.
 */

function toDate(value: string | Date | null | undefined): Date | null {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** true se la data dell'offerta cade nel giorno di `now` (fuso orario del browser). */
export function isOfferDateToday(createdAt: string | Date | null | undefined, now: Date = new Date()): boolean {
  const d = toDate(createdAt);
  if (!d) return false;
  return (
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate()
  );
}

/** true se ha senso chiedere: data valida, diversa da oggi. */
export function shouldAskOfferDateRefresh(createdAt: string | Date | null | undefined, now: Date = new Date()): boolean {
  return toDate(createdAt) !== null && !isOfferDateToday(createdAt, now);
}

/** Data nel formato del PDF (gg/mm/aaaa). */
export function formatOfferDate(value: string | Date | null | undefined): string {
  const d = toDate(value);
  return d ? d.toLocaleDateString('it-IT') : '';
}
